import { Circle, Point } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import FeatureDrawer from '../helpers/FeatureDrawer';
import MapElement from './MapElement';
import RegularShape from 'ol/style/RegularShape';


import Select from 'ol/interaction/Select';
import { always, singleClick } from 'ol/events/condition';

export default class MapRBPDrivingLines extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent);
    }


    drawLayer(data, projection) {
        var featureDrawer = new FeatureDrawer(projection, this.mapModel.projection);
        var features = [];
        var style = function (ft, res) {
            return new Style({
                stroke: new Stroke({
                    color: "gray",
                    width: 3
                }),
            });
        }


        for (const key in data) {
            const value = data[key];
            var polyLinePoints = [];


            value.forEach((vertex) => {
                polyLinePoints.push({ x: vertex.xspray, y: vertex.yspray });
            });
            var feature = featureDrawer.drawFeature({ type: "POLYLINE", vertices: polyLinePoints });
            feature.set("name", key);
            features.push(feature);

        }
        var source = new VectorSource();
        source.addFeatures(features);

        this.layer = new VectorLayer({
            source: source,
            style: style,
        });

        this.parent.layer.getLayers().push(this.layer);

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }
}